import Grid from '@material-ui/core/Grid';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';

import Collection from '../Model/Collection';

import ItemTableRow from '../Components/ItemTableRow';
import FormShareCard from '../Components/FormShareCard';
import FormShareCollectionFields from '../Model/FormShareCollectionFields';

import {
  GetUserOrganizationFormSharesPathForApi,
} from '../Util/api';
import {
  GetDateValue,
  GetUserValue,
} from '../Util/Properties';
import {
  IsUserProjectAdmin,
} from '../Util/User';
import {
  HandleRouteToFormInput,
} from '../Util/FormTemplates';
import {
  GetTagsForList,
} from '../Util/Tags';

// import { IsMobile } from '../Util/MobileDetector';

export class FormShares_Collection extends Collection {
  constructor(props, onSetState, onApiError, onAlert, isWorkspace, isProjects, 
    organizationId, projectId, context, isUserAssignmentContext) {

    if (typeof organizationId !== "string") {
      console.log("Warning: organizationId required and not found");
    }

    super(props, onSetState, onApiError, isWorkspace, isProjects, organizationId, projectId, context);

    this.handleAlert = onAlert;

    this.PageTitle = "Shared Forms";
    this.ContentUri = (isUserAssignmentContext)
      ? GetUserOrganizationFormSharesPathForApi(organizationId)
      : "";//GetFormSharesPathForApi(organizationId, projectId);
    this.ContentUriParams = (isUserAssignmentContext)
      ? { projectId }
      : undefined;
    this.CollectionName = "FormShares";
    this.ItemsName = "FormShares";
    this.ItemName = "Shared Form";
    this.DefaultViewType = "Card";

    this.CanSelectItem = item => false;
  }

  HandleGetCollectionFieldsPromise = () => Promise.resolve(FormShareCollectionFields);

  HandleGetHeadCells = (items, sensitiveFields) => {
    let headCells = [
      { id: 'Name', sortId: 'Meta_text_kw256lc[Name].keyword', numeric: false, label: 'Name' },
      { id: 'Email', sortId: 'Meta_text_kw256lc[AssignmentUserEmail].keyword', numeric: false, label: 'Shared with' },
    ];
    if (!this.ProjectID) {
      headCells.push(
        { id: 'ProjectName', sortId: 'Meta_text_kw256lc[ProjectName].keyword', numeric: false, label: "Project" },
      );
    }
    headCells.push(
      { id: 'CreatedOn', sortId: 'Meta_date_str256[CreatedOn].string', numeric: false, label: 'Created On' },
      { id: 'Tags', sortId: 'Meta_text_kw50lc[Tag].keyword', numeric: false, label: 'Tags' },
    );
    return headCells;
  }

  HandleGetCardGridItems = (items, sensitiveFields, classes, theme, onSelect, selectedIDs, onAction, postActionData, sortType, sortDescending) => {
    return (items && items.length) 
      ? items
        .map(i => {
          return (
            <Grid item key={i.ID} sm={12} md={6} lg={4} xl={3} className={classes.cardGridItem}>
              <FormShareCard
                minHeight={120}
                FormShare={i}
                history={this.props.history}
                onAction={onAction}
                onCardAction={() => HandleRouteToFormInput(i.FormTemplateID, i.FormTemplateUniqueID, i.ID)}
                showFormInputAction
                showFormTemplateDesignerAction={IsUserProjectAdmin(this.context, i.ProjectID)}
                onSelect={(this.CanSelectItem(i)) ? () => onSelect(i.ID) : undefined}
                noSelect={!this.CanSelectItem(i)}
                selected={selectedIDs.indexOf(i.ID) > -1}
              />
            </Grid>
          );
        }) 
      : [];
  }

  HandleGetTableRows = (headCells, items, sensitiveFields, classes, theme, onSelect, selectedIDs, onAction, postActionData, sortType, sortDescending) => {
    return (items && items.length)
      ? items
        .map(i => {
          const selected = selectedIDs.indexOf(i.ID) !== -1;
          const projectNameCell = (!this.ProjectID)
            ? <TableCell className={classes.tableCell}>{i.ProjectName}</TableCell>
            : null;
          const labelId = `label_${i.ID}`;
          return (
            <ItemTableRow key={`k_${i.ID}`}
              onItemClick={() => HandleRouteToFormInput(i.FormTemplateID, i.FormTemplateUniqueID, i.ID)}
            >
              <TableCell className={classes.tableCell_FirstCell} padding="checkbox">
                <Checkbox
                  style={{
                    visibility: (!this.CanSelectItem(i)) ? "hidden" : undefined,
                  }}
                  color="secondary"
                  onClick={event => { event.stopPropagation(); onSelect(i.ID); }}
                  checked={selected}
                  inputProps={{ 'aria-labelledby': labelId, style:{zIndex:0} }}
                />
              </TableCell>
              <TableCell className={classes.tableCell} component="th" id={`label_${i.ID}`} scope="row" padding="none">
                {i.FormTemplateName}
              </TableCell>
              <TableCell className={classes.tableCell}>{GetUserValue(i.AssignmentUserEmail, i.AssignmentUserName)}</TableCell>
              {projectNameCell}
              <TableCell className={classes.tableCell}>{GetDateValue(i.CreatedOn)}</TableCell>
              <TableCell className={classes.tableCell}>
                {GetTagsForList(i, sortType, sortDescending)}
              </TableCell>
            </ItemTableRow>
          );
        }) 
      : [];
  }
}